import { render, staticRenderFns } from "./Spare.vue?vue&type=template&id=fabd629a&scoped=true"
import script from "./Spare.vue?vue&type=script&lang=js"
export * from "./Spare.vue?vue&type=script&lang=js"
import style0 from "./Spare.vue?vue&type=style&index=0&id=fabd629a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd629a",
  null
  
)

export default component.exports